/**
 * <search-tabs> — Products / Pages / Journal tabs on the search results page.
 * Tabs: button[role=tab][data-tab]; panels: [role=tabpanel][data-panel]. Arrow keys move between tabs.
 */
class SearchTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = [...this.querySelectorAll('[role="tab"]')];
    this.panels = [...this.querySelectorAll('[data-panel]')];
    for (const tab of this.tabs) {
      tab.addEventListener('click', () => this.#select(tab));
      tab.addEventListener('keydown', (event) => {
        const index = this.tabs.indexOf(tab);
        let next = null;
        if (event.key === 'ArrowRight') next = this.tabs[(index + 1) % this.tabs.length];
        if (event.key === 'ArrowLeft') next = this.tabs[(index - 1 + this.tabs.length) % this.tabs.length];
        if (next) {
          event.preventDefault();
          this.#select(next);
          next.focus();
        }
      });
    }
    this.#syncTabindex();
  }

  #select(selected) {
    for (const tab of this.tabs) tab.setAttribute('aria-selected', String(tab === selected));
    for (const panel of this.panels) panel.hidden = panel.dataset.panel !== selected.dataset.tab;
    this.#syncTabindex();
  }

  #syncTabindex() {
    for (const tab of this.tabs) tab.tabIndex = tab.getAttribute('aria-selected') === 'true' ? 0 : -1;
  }
}

if (!customElements.get('search-tabs')) customElements.define('search-tabs', SearchTabs);
